import { supabase } from '@/integrations/supabase/client';

export type CurrentUser = {
  id: string;
  email: string;
  user_metadata?: {
    first_name?: string;
    last_name?: string;
  };
};

function getPinSessionUser(): CurrentUser | null {
  if (typeof window === 'undefined') return null;

  const authMethod = window.localStorage.getItem('auth_method');
  const isAuth = window.localStorage.getItem('is_authenticated') === 'true';
  if (authMethod !== 'pin' || !isAuth) return null;

  const id = window.localStorage.getItem('pin_user_id') || '';
  const email = window.localStorage.getItem('pin_user_email') || '';
  const name = window.localStorage.getItem('pin_user_name') || '';

  if (!id) return null;

  const [first_name, ...rest] = name.split(' ').filter(Boolean);
  const last_name = rest.join(' ');

  return {
    id,
    email,
    user_metadata: {
      first_name: first_name || undefined,
      last_name: last_name || undefined,
    },
  };
}

/**
 * Retourne l’utilisateur “courant” en supportant :
 * - Auth PIN (session dans localStorage)
 * - Auth Supabase (session Supabase)
 *
 * Important: on évite d’appeler `supabase.auth.getUser()` si aucune session
 * Supabase n’existe, pour prévenir des erreurs réseau/console (400).
 */
export async function getCurrentUser(): Promise<CurrentUser | null> {
  const pinUser = getPinSessionUser();
  if (pinUser) return pinUser;

  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) return null;
  if (!sessionData.session) return null;

  const { data, error } = await supabase.auth.getUser();
  if (error) return null;
  if (!data.user) return null;

  return {
    id: data.user.id,
    email: data.user.email ?? '',
    user_metadata: (data.user.user_metadata ?? {}) as CurrentUser['user_metadata'],
  };
}
